
import Navbar from './../Navbar';
import { React } from 'react';
import daddyImage from '../images/shots/daddy.JPG';
import jamVanImage from '../images/shots/jam_van.JPG';
import './Epk.css';

function Epk() {
  return (
    <div className="content-home">
      <Navbar />
      <div className="background-home">
        <div className="overlay">
          <div className="content">
            <div className="bioContainer">
              <img 
                src={daddyImage} 
                alt="Daddy" 
                className="artistPic" 
              />
              <div className="bioText">
                <div>
                  <h1>WE ARE TROPHY EDDY</h1>
                  <h2>Quick Facts:</h2>
                  <h3>
                    Genres: Alt-rock, grunge, pop rock <br />
                    Instrumentation: Vocals, guitar, bass, drums <br />
                    Influences: The Police, Radiohead, Red Hot Chili Peppers<br />
                    Location: West LA
                    <br /> <br />
                  </h3>
                  <h3>
                    Trophy Eddy is a genre fusing, alt-rock band based in West LA. 
                    Their sonic foundation is built on the hazy warmth 
                    of soft-rock radio music combined with post-punk DIY ethics,
                    while their exterior is colored by sneaky 70’s funk rhythms. 
                    The four-piece band showcases deep grooves, sharp melodies, 
                    and an edge that keeps things unpredictable. <br /> <br />  
                    Music that is fresh but familiar because it pulls inspiration from 
                    a succession of artists, for example, The Police, Radiohead, Men I Trust, and Willow. <br /><br />
                    
                    Solia Mayo is the leading voice and lyricist, commanding crowd 
                    energy with every note. Tommy Escalante is the lead guitarist, 
                    effortlessly blending his classical training with sounds of his home
                    country, Argentina. On bass is Zoe Webster, a stylish musical mastermind 
                    in charge of each song’s momentum, and on drums is Hunter Krasa, the punctual 
                    commander behind Trophy Eddy’s rhythm section.
                  </h3>
                </div>
              </div>
              <img 
                src={jamVanImage} 
                alt="Jam Van" 
                className="artistPic" 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Epk;